<div class="items-view">
    @if (title()) {
        <h6 class="fw-bold mb-2">{{ title() }}</h6>
    }

    <div class="row g-3">
        @for (column of columns(); track column.side) {
            <section class="col-12" [class.col-lg-6]="column.label" [attr.data-column]="column.side">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    @if (column.label) {
                        <span class="fw-bold text-primary">{{ column.label | translate }}</span>
                    }
                    <span class="badge text-bg-primary ms-auto">{{ "data_entry.selected_items" | translate }}: {{ column.rows.length }}</span>
                </div>

                @if (column.rows.length) {
                    <div class="list-group">
                        @for (row of column.rows; track row.link.operationStrategicTaskId) {
                            <div class="list-group-item" [class.has-diff]="row.hasDiff">
                                <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
                                    <span class="fw-semibold">{{ row.link | translateToken: "operationStrategicTaskName" }}</span>
                                    <span class="badge text-bg-light border fw-normal">
                                        {{ "operations_strategic_tasks.procedures" | translate }}: {{ row.procedureCount }}
                                    </span>
                                </div>

                                @if (row.procedures.length) {
                                    <table class="table table-sm table-borderless align-middle mt-2 mb-0 bg-transparent">
                                        <thead class="border-bottom">
                                            <tr class="small text-muted">
                                                <th class="fw-normal bg-transparent">{{ "operations_strategic_tasks.procedure" | translate }}</th>
                                                <th class="fw-normal bg-transparent w-25">
                                                    {{ "operations_strategic_tasks.responsibility_type" | translate }}
                                                </th>
                                                <th class="fw-normal bg-transparent w-25">{{ "data_entry.ai_agents" | translate }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (procedureRow of row.procedures; track procedureRow.procedure.id) {
                                                <tr [class.has-diff]="procedureRow.hasDiff">
                                                    <td class="bg-transparent">{{ procedureRow.procedure | translateToken: "name" }}</td>
                                                    <td class="bg-transparent">
                                                        {{ procedureRow.procedure | translateToken: "responsibilityTypeName" }}
                                                    </td>
                                                    <td class="bg-transparent">
                                                        <span class="d-flex flex-wrap gap-1">
                                                            @for (agent of procedureRow.procedure.aiAgents; track agent.id) {
                                                                <span class="badge text-bg-light border fw-normal">{{
                                                                    agent | translateToken: "name"
                                                                }}</span>
                                                            }
                                                        </span>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                }
                            </div>
                        }
                    </div>
                } @else {
                    <p class="text-center text-muted border rounded py-3 mb-0">{{ "common.tables.no_info" | translate }}</p>
                }
            </section>
        }
    </div>
</div>
